module.exports = __webpack_public_path__ + "img/Caribbean Meal-Pork.d902fa54.jpg";